import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { preFillHubInterestACQ134 } from '../../experiments/acq134/acq134Utils';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { Step } from '../../views/Step';
export const BranchACQ134VariantB = {
  name: 'BranchACQ134VariantB',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0134, [ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    let preVerification = [Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.LandingPage, Step.CodeVerification];

    if (!getIsMobile()) {
      preVerification = NextStepManager.removeSteps(Step.HubOption)(preVerification);
    }

    preFillHubInterestACQ134(dispatch);
    const postVerification = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
    const postAccountCreationSteps = getIsMobile() ? [Step.MobileAppPrompt] : [];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerification, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerification, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};